module.exports = __webpack_public_path__ + "static/media/Quail.svg";